export const formatTimestamp = (timestamp) => {
  const date = timestamp.toDate();
  let optionsDate = {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  };
  let optionsTime = {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  };
  let formattedDate = new Intl.DateTimeFormat("default", optionsDate).format(
    date
  );
  let formattedTime = new Intl.DateTimeFormat("default", optionsTime).format(
    date
  );
  return { date: formattedDate, time: formattedTime };
};

export const formatTimeRange = (start, end) => {
  start = start.toDate();
  end = end.toDate();
  let options = {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  };
  let formattedRange = new Intl.DateTimeFormat("default", options).formatRange(
    start,
    end
  );
  return formattedRange;
};
